/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ size: NonNullable<unknown> }} Vp_Blocked_Table_SizeInputs */



/**
* | output |
* | --- |
* | "A table of {size} cannot be scored — tables seat 4 or 5." |
*
* @param {Vp_Blocked_Table_SizeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vp_blocked_table_size = /** @type {((inputs: Vp_Blocked_Table_SizeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vp_Blocked_Table_SizeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Une table de ${i?.size} ne peut pas être notée : les tables comptent 4 ou 5 joueurs.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Una mesa de ${i?.size} no se puede puntuar: las mesas son de 4 o 5.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Uma mesa de ${i?.size} não pode ser pontuada: as mesas têm 4 ou 5 lugares.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Un tavolo da ${i?.size} non può essere valutato: i tavoli sono da 4 o 5.`)
	return /** @type {LocalizedString} */ (`A table of ${i?.size} cannot be scored — tables seat 4 or 5.`)
});